import React from "react"

export default ({ placeholder, onChange, value, onKeyDown, className, disabled }) => {
  return (
    <label className={"radius-4 " + className} {...(disabled ? { style: { opacity: .45 } } : {})}>
      <div className="flexed fdir-col">
        <div className="p-16 inline-flexed align-c text-shadow">
          <span className="font-12">{placeholder}</span></div>
        <div className="flex-1 w-100">
          <textarea disabled={disabled} onChange={e => {
            onChange(e.target.value)
          }} value={value}
            style={{ minHeight: 128 }}
            onKeyDown={e => onKeyDown && onKeyDown(e)}
            className="bd-none bg-none w-100 dropdown py-8 px-16 font-14 iran-sans-medium iran-sans w-100 text-shadow blocked" />
        </div>
      </div>

    </label>
  )
}
